export function init() {
    const headerNavigation = document.querySelector('.header-navigation');
    const mainNavigationCloseSubMenu = headerNavigation.querySelector('.header-navigation__close-sub-menu');
    const mainNavigation = headerNavigation.querySelector('.main-navigation');
    const mainNavigationItems = mainNavigation.querySelectorAll('.main-navigation__item');
    const burger = headerNavigation.querySelector('.header-navigation__burger');

    burger.addEventListener('click', () => {
        document.body.classList.toggle('menu-open');
        mainNavigation.classList.toggle('open');

        if (document.body.classList.contains('sub-menu-open')) {
            document.body.classList.remove('sub-menu-open');

            mainNavigationItems.forEach(
                (item) => {
                    item.classList.remove('open');
                }
            );
        };
    });

    mainNavigationItems.forEach(
        (item) => {
            const mobileNavigationArrow = item.querySelector('.main-navigation__mobile-link');

            if (mobileNavigationArrow) {
                mobileNavigationArrow.addEventListener('click', () => {
                    document.body.classList.add('sub-menu-open');

                    item.classList.add('open');
                });
            }
        }
    );

    mainNavigationCloseSubMenu.addEventListener('click', () => {
        document.body.classList.remove('sub-menu-open');

        mainNavigationItems.forEach(
            (item) => {
                item.classList.remove('open');
            }
        );
    });
}

export default {
    init
};
